import { useCapability, useComponentState, useToggleComponent } from 'navigation-components/platform/hooks';
import { useCallback, useEffect } from 'react';
import { capabilities } from 'navigation-components/capabilities';
import { GLOBAL_SEARCH_COMPONENT } from 'navigation-components/config';
import { SEARCH_TRACKING_CONSTANTS } from '../constants';
import { isKeyboardShortcut } from 'global-search-shared/utils/isKeyboardShortcut';
const isInEditor = event => {
  if (event.target) {
    const t = event.target;
    if (t.closest('div[contenteditable="true"]')) {
      return true;
    }
  }
  return false;
};
const isRealKeyboardEvent = event => 'preventDefault' in event && 'stopPropagation' in event && typeof event.preventDefault === 'function' && typeof event.stopPropagation === 'function';
const useKeyboardShortcutsGlobal = ({
  isMac,
  trackSearchEvent
}) => {
  const {
    isOpen
  } = useComponentState(GLOBAL_SEARCH_COMPONENT);
  const {
    subscribe: subscribeGlobalKeyboardEvents
  } = useCapability(capabilities.GLOBAL_KEYBOARD_SHORTCUT_HANDLER_CAP.getName());
  const {
    toggle
  } = useToggleComponent(GLOBAL_SEARCH_COMPONENT);
  const globalKeyboardShortcutHandler = useCallback(event => {
    const {
      isValidShortcut,
      isGlobal
    } = isKeyboardShortcut(event);
    if (isValidShortcut && isGlobal) {
      if (isRealKeyboardEvent(event)) {
        if (isInEditor(event)) {
          return;
        }
        event.preventDefault();
        event.stopPropagation();
      }
    }
    if ((isMac ? event.metaKey : event.ctrlKey) && event.key === 'k') {
      trackSearchEvent({
        type: isOpen ? SEARCH_TRACKING_CONSTANTS.CLOSE : SEARCH_TRACKING_CONSTANTS.OPEN,
        value: SEARCH_TRACKING_CONSTANTS.KEYBOARD
      });
      toggle();
    }
  }, [isMac, isOpen, toggle, trackSearchEvent]);
  const handleGlobalKeyboardEventFromComponent = useCallback(arg => {
    globalKeyboardShortcutHandler(arg.keyboardEventKeys);
  }, [globalKeyboardShortcutHandler]);
  useEffect(() => {
    return subscribeGlobalKeyboardEvents(handleGlobalKeyboardEventFromComponent);
  }, [handleGlobalKeyboardEventFromComponent, subscribeGlobalKeyboardEvents]);
  useEffect(() => {
    window.addEventListener('keydown', globalKeyboardShortcutHandler);
    return () => {
      window.removeEventListener('keydown', globalKeyboardShortcutHandler);
    };
  }, [globalKeyboardShortcutHandler]);
};
export default useKeyboardShortcutsGlobal;